import { createContext } from 'react';
import { MIN_HEIGHT, MAX_HEIGHT } from './constants';

/**
 * @ignore - Do not document.
 */
const DropdownContext = /*#__PURE__*/createContext({
  minHeight: MIN_HEIGHT,
  maxHeight: MAX_HEIGHT
});
export default DropdownContext;